import { z } from "zod";
import { ExtraKg, Reps, WeightKg } from "./bounds.js";

// Intra-set chain on one parent set, shared by LogSet and WorkoutSet.
//   - "classical": weight drops, max reps, no rest.
//   - "myorep": same weight, fewer reps, rest-pause.
// A step without weight/extra reads as "same load as the parent".
// Variant lives on the chain: a real chain never mixes the two.
const DropsetVariant = z.enum(["classical", "myorep"]);
const DropsetStep = z.object({
  reps: Reps,
  weight: WeightKg.optional(),
  extra: ExtraKg.optional(),
  // Set when the lifter marks the step done. Absent on pending steps and
  // on rows saved before this field existed.
  completedAt: z.iso.datetime().optional(),
});
export const Dropset = z.object({
  variant: DropsetVariant,
  steps: z.array(DropsetStep).min(1).max(8),
});
export type Dropset = z.infer<typeof Dropset>;
